import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import color from '@/constants/colors';
Vue.use(Vuetify);
export default new Vuetify({
    theme: {
        dark: true,
        themes: {
            light: Object.assign({ primary: color.light.SYSTEM.DARK_9, secondary: color.light.ACCENT.BLUE_BASE }, color.light),
            dark: Object.assign({ primary: color.dark.SYSTEM.DARK_9, secondary: color.light.ACCENT.BLUE_BASE }, color.dark)
        }
    }
});
